<template>
    <div>
        <div class="top_title fixed">
            <span v-if="show">{{isset ?'修改':'设置'}}支付密码</span>
        </div>
        <div class="wd_tips">
            <img class="wd_icon" src="../../assets/bx/warning.png" alt="" />
            <i>提醒：</i>在进行商品购买时需要支付密码验证，避免误购商品。请不要随意向他人泄露自己的支付密码，因此造成的纠纷平台概不负责
        </div>
        <div class="step00" v-if="step == -1">
            <el-form class="box">
                <el-form-item>请输入旧密码</el-form-item>
                <el-form-item class="pwd_area flex center" style="background-color: #fff;">
                    <div class="otpInputs otpInputs1">
                        <el-input v-model="oldpsd" type="number" oninput="if(value.length > 6) value=value.slice(0, 6)">
                        </el-input>
                        <span class="code_list">{{ oldpsd1 }}</span>
                        <span class="code_list">{{ oldpsd2 }}</span>
                        <span class="code_list">{{ oldpsd3 }}</span>
                        <span class="code_list">{{ oldpsd4 }}</span>
                        <span class="code_list">{{ oldpsd5 }}</span>
                        <span class="code_list last_code_list">{{ oldpsd6 }}</span>
                    </div>
                </el-form-item>
            </el-form>
            <div class="btns">
                <van-button class="pre_btn" @click="step = 0">上一步</van-button>
                <van-button :disabled="disabled0" class="next_btn" type="info" @click="next(-1)">下一步</van-button>
            </div>
        </div>
        <div class="step0" v-else-if="step == 0&&show">
            <div class="setpsdbtns">
                <el-button type="primary" @click="ymm">记得原密码</el-button>
                <el-button type="default" @click="step = 1">忘记原密码</el-button>
            </div>
        </div>
        <div class="step1" v-else-if="step == 1&&show">
            <el-form :model="actionData" class="box" ref="box1" @submit.native.prevent>
                <el-form-item>请输入手机<span style="color: var(--warning);">{{ mobile }}</span>收到的短信验证码</el-form-item>
                <el-form-item prop="code" :rules="rules.captcha">
                    <div class="code_area">
                        <el-input v-model="actionData.code" type="number"
                            oninput="if(value.length > 6) value=value.slice(0, 6)" class="lwc_code" placeholder="短信验证码">
                        </el-input>
                        <el-button :class="{ lwc_primary: true, lwc_disabled: isdisabled }" :disabled="isdisabled"
                            @click="sendCode">{{ buttonName }}</el-button>
                    </div>
                </el-form-item>
            </el-form>
            <div class="btns">
                <van-button class="pre_btn" v-if="isset" @click="step = 0">上一步</van-button>
                <van-button class="next_btn" type="info" @click="next(1)">下一步</van-button>
            </div>
        </div>

        <div class="step3" v-else-if="step == 2">
            <el-form class="box">
                <el-form-item>请设置6位数字支付密码</el-form-item>
                <el-form-item class="pwd_area flex center" style="background-color: #fff;">
                    <div class="otpInputs otpInputs2">
                        <el-input v-model="psd" type="number" oninput="if(value.length > 6) value=value.slice(0, 6)">
                        </el-input>
                        <span class="code_list">{{ psd1 }}</span>
                        <span class="code_list">{{ psd2 }}</span>
                        <span class="code_list">{{ psd3 }}</span>
                        <span class="code_list">{{ psd4 }}</span>
                        <span class="code_list">{{ psd5 }}</span>
                        <span class="code_list last_code_list">{{ psd6 }}</span>
                    </div>
                </el-form-item>

            </el-form>
            <div class="btns">
                <el-button class="next_btn" type="primary" :disabled="disabled1" @click="next(2)">下一步</el-button>
            </div>
        </div>
        <div class="step3" v-else-if="step == 3">
            <el-form class="box">
                <el-form-item>请再次输入6位数字支付密码</el-form-item>
                <el-form-item class="pwd_area flex center" style="background-color: #fff;">
                    <div class="otpInputs otpInputs3">
                        <el-input v-model="psdaga" type="number" oninput="if(value.length > 6) value=value.slice(0, 6)">
                        </el-input>
                        <span class="code_list">{{ psdaga1 }}</span>
                        <span class="code_list">{{ psdaga2 }}</span>
                        <span class="code_list">{{ psdaga3 }}</span>
                        <span class="code_list">{{ psdaga4 }}</span>
                        <span class="code_list">{{ psdaga5 }}</span>
                        <span class="code_list last_code_list">{{ psdaga6 }}</span>
                    </div>
                </el-form-item>
            </el-form>
            <div class="btns">
                <el-button class="pre_btn" @click="step=2">上一步</el-button>
                <el-button class="next_btn" type="primary" :disabled="disabled2" :loading="lodaing > 0"
                    @click="next(3)">完成</el-button>
            </div>
        </div>
    </div>
</template>
<script>
    import $ from 'jquery'
    export default {
        data() {
            return {
                mobile: '',
                isset: null,
                actionData: {
                    code: ''
                },
                code: "",
                psd: "",
                psd1: "",
                psd2: "",
                psd3: "",
                psd4: "",
                psd5: "",
                psd6: "",
                psdaga: "",
                psdaga1: "",
                psdaga2: "",
                psdaga3: "",
                psdaga4: "",
                psdaga5: "",
                psdaga6: "",
                oldpsd: '',
                oldpsd1: '',
                oldpsd2: '',
                oldpsd3: '',
                oldpsd4: '',
                oldpsd5: '',
                oldpsd6: '',
                isdisabled: false,
                buttonName: "获取验证码",
                time: 58,
                step: 1,
                show: false,
                disabled0: true,
                disabled1: true,
                disabled2: true,
                lodaing: 0
            }
        },
        filters: {
            plusX(str) {
                var x = "****";
                if (str.length >= 6) {
                    return (
                        str.substring(0, 3) + x + str.substring(str.length - 4, str.length)
                    );
                } else {
                    return str;
                }
            },
        },
        computed: {
            rules() {
                const {
                    captcha
                } = this.$store.getters.rules;
                return {
                    captcha
                }
            }
        },
        mounted() {
            this.getIsSet()
        },
        methods: {
            getIsSet() {
                this.$Ajax('pay-password/isset', {}, 'get').then(rs => {
                    if (rs.code == 200) {
                        this.show = true
                        this.mobile = rs.data.mobile
                        this.isset = rs.data.isset
                        if (this.isset) {
                            this.step = 0
                        }
                    }
                })
            },
            pre(i) {
                if (i == 2) {
                    this.step = 1;
                }
            },
            next(i) {
                if (i == -1) {
                    this.$Ajax('pay-password/check', {
                        password: this.oldpsd
                    }).then(rs => {
                        if (rs.code == 200) {
                            this.step = 2
                            setTimeout(() => {
                                $('.otpInputs2 input').focus()
                            }, 100)
                        }
                    })
                } else if (i == 1) {
                    this.$refs.box1.validate(valid => {
                        if (valid) {
                            this.$Ajax("pay-password/check-code", {
                                action: this.isset ? 'reset_pwd' : 'set_pwd',
                                code: this.actionData.code,
                            }).then(rs => {
                                if (rs.code == 200) {
                                    this.step = 2;
                                    setTimeout(() => {
                                        $('.otpInputs2 input').focus()
                                    }, 100)
                                }
                            });
                        }
                    })
                } else if (i == 2) {
                    this.step = 3
                    setTimeout(() => {
                        $('.otpInputs3 input').focus()
                    }, 100)
                } else if (i == 3) {
                    if (this.psd != this.psdaga) {
                        this.$toast('两次密码输入不一致')
                    } else {
                        this.loading++
                        this.$Ajax('pay-password/set', {
                            password: this.psd,
                            repassword: this.psdaga
                        }).then(rs => {
                            if (rs.code == 200) {
                                this.$toast(rs.msg)
                                this.$router.push({
                                    name: 'user.center'
                                })
                            }
                        }).finally(() => {
                            setTimeout(() => {
                                this.loading = 0
                            }, 2000)
                        })
                    }
                }
            },
            sendCode() {
                var that = this;
                $('.lwc_code input').focus()
                this.isdisabled = true;
                this.$Ajax("pay-password/send-code", {
                    action: this.isset ? 'reset_pwd' : 'set_pwd'
                }).then(rs => {
                    this.$toast(rs.msg);
                    if (rs.code == 200) {
                        that.buttonName = "重新发送(59)s";
                        let interval = window.setInterval(function () {
                            that.buttonName = "重新发送(" + that.time + ")s";
                            that.time--;
                            if (that.time < 0) {
                                that.buttonName = "重新发送";
                                that.time = 58;
                                that.isdisabled = false;
                                window.clearInterval(interval);
                            }
                        }, 1000);
                    }else {
                        that.buttonName = "重新发送";
                        that.time = 58;
                        that.isdisabled = false;
                    }
                });
            },
            ymm() {
                this.oldpsd = ''
                this.disabled0 = true
                this.step = -1;
                setTimeout(() => {
                    $('.otpInputs1 input').focus()
                }, 100)
            }
        },
        watch: {
            psd: {
                immediate: true,
                handler(val) {
                    let arr = val.split("");
                    this.psd1 = arr[0];
                    this.psd2 = arr[1];
                    this.psd3 = arr[2];
                    this.psd4 = arr[3];
                    this.psd5 = arr[4];
                    this.psd6 = arr[5];
                    if (val.length == 6) {
                        this.disabled1 = false
                    } else {
                        this.disabled1 = true
                    }
                }
            },
            psdaga: {
                immediate: true,
                handler(val) {
                    let arr = val.split("");
                    this.psdaga1 = arr[0];
                    this.psdaga2 = arr[1];
                    this.psdaga3 = arr[2];
                    this.psdaga4 = arr[3];
                    this.psdaga5 = arr[4];
                    this.psdaga6 = arr[5];
                    if (val.length == 6) {
                        this.disabled2 = false
                    } else {
                        this.disabled2 = true
                    }
                }

            },
            oldpsd: {
                immediate: true,
                handler(val) {
                    let arr = val.split("");
                    this.oldpsd1 = arr[0];
                    this.oldpsd2 = arr[1];
                    this.oldpsd3 = arr[2];
                    this.oldpsd4 = arr[3];
                    this.oldpsd5 = arr[4];
                    this.oldpsd6 = arr[5];
                    if (val.length == 6) {
                        this.disabled0 = false
                    }
                }
            },
        }
    }
</script>
<style lang="less" scoped>
    .box-item {
        background-color: #fff;
        display: flex;
        align-items: center;
        height: 3.6rem;
        padding: 0 1.6rem;
        border-radius: 0.6rem;
        font-size: 1.4rem;

        img {
            width: 1.85rem;
            height: 1.85rem;
            margin-right: 0.6rem;
        }

        .prefix {
            width: 6.8rem;
        }

        /deep/.amount_ipt {
            flex: 1;

            .el-input__inner {
                width: 100%;
                padding: 0;
                border: none;
            }
        }
    }

    .wd_tips {
        height: 6rem;
        padding: 1rem;
        line-height: 2rem;
        color: #aaa;
        margin-bottom: 2rem;

        .wd_icon {
            width: 1.15rem;
            height: 1.15rem;
            margin-right: 0.4rem;
            margin-bottom: 0.35rem;
        }

        i {
            color: var(--warning);
            word-break: break-all;
        }
    }

    .el-form-item {
        margin-bottom: 0;
        border-bottom: 1px solid #eee;

        i {
            color: var(--warning);
        }
    }

    /deep/.el-form-item__content {
        display: flex;
        align-items: center;
        background-color: #fff;
        border-radius: 0.3rem;
        padding-left: 1.2rem;
        font-size: 1.4rem;

        .label {
            width: 5rem;
            font-size: 1.3rem;
        }

        .el-input {
            flex: 1;
            border: none;
            outline: none;

            input {
                border: none;
                outline: none;
                text-align: start;
                padding: 0;
                font-size: 1.3rem;
            }
        }

        .el-form-item__error {
            left: 1rem;
            right: unset;
            z-index: 10;
            top: 100%;
        }
    }

    .box {
        margin-bottom: 6rem;
    }

    .next_btn {
        width: 18rem;
        height: 3rem;
        border-radius: 10rem;
        margin: 0 auto;
        display: flex;
        justify-content: center;
        align-items: center;
        font-size: 1.2rem;
    }

    .code_area {
        width: 100%;
        height: 4.4rem;
        display: flex;
        // border: 1px solid #dcdee6;
        // border-radius: 4px;
        position: relative;

        &:hover {
            border-color: #c0c4cc;
        }

        /deep/.el-input__inner {
            height: 100%;
            font-size: 1.4rem;
            padding: 0 1.6rem;
            padding-right: 10rem;
        }

        .lwc_primary {
            position: absolute;
            right: 0.6rem;
            top: 50%;
            transform: translateY(-50%);
            -webkit-tap-highlight-color: transparent;
            border: none;
            color: var(--theme);
            font-size: 1.2rem;
            background-color: var(--xq);
            color: #fff;
            width: 8.5rem;
            height: 2.5rem;
            line-height: 2.5rem;
            display: flex;
            align-items: center;
            justify-content: center;

            &:visited,
            &:hover,
            &:active {
                opacity: 0.9;
            }

            &.is-disabled {
                background-color: #999;
            }
        }
    }

    //step2
    .btns {
        display: flex;
        justify-content: space-around;

        .next_btn {
            width: 14rem;
        }

        .pre_btn {
            width: 14rem;
            height: 3rem;
            border-radius: 10rem;
            margin: 0 auto;
            display: flex;
            justify-content: center;
            align-items: center;
            font-size: 1.2rem;
        }
    }

    //step3
    .success {
        display: flex;
        justify-content: center;
        align-items: center;
        flex-direction: column;
        background-color: #fff;
        padding: 4rem 0;
        border-radius: 0.4rem;
        margin-bottom: 4rem;

        img {
            width: 3.1rem;
            height: 3.1rem;
            margin-bottom: 1rem;
        }
    }

    .setpsdbtns {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;

        .el-button {
            margin: 1rem 0;
            width: 12rem;
            height: 3.6rem;
            font-size: 1.4rem;
        }
    }
</style>